import { isElement, isString } from 'lodash';

export default class Preset {
    constructor({ debug, INJECTION_PARENT, injectMethod }) {
        this.debug = debug;
        this.injectionParent = null;
        this.injectMethod = injectMethod;

        if (INJECTION_PARENT) this.INJECTION_PARENT = INJECTION_PARENT;
    }

    // the parent container for injecting widget
    // We'll need to consider how to handle multiple product forms on a page. We do something similair in index.js
    INJECTION_PARENT = 'form[action*="cart/add"]';

    // the name of the preset
    get name() {
        throw new Error('name not implemented');
    }

    _getEl(selectorOrEl) {
        // ar is selector
        if (isString(selectorOrEl)) {
            return document.querySelector(selectorOrEl);
        }

        // arg is an html node element
        if (isElement(selectorOrEl)) {
            return selectorOrEl;
        }

        return null;
    }

    // parent container where Widget will be injected into
    get injectionParentEl() {
        return this._getEl(this.INJECTION_PARENT);
    }

    _safeInject(...args) {
        try {
            this.inject(...args);
        } catch (e) {
            console.error(`Failed to inject.`, e);
        }
    }

    // the function that injects the widget to its parent
    inject(widget, parent) {
        const pointOfInjection = parent || this.injectionParentEl;
        const methodName = this.injectMethod || 'prepend';
        pointOfInjection[methodName](widget);

        this.injectionParent = pointOfInjection;
    }
}
